module.exports = __webpack_public_path__ + "static/img/img_gy_e_g.363468aa.png";